import React, { useContext, useState } from "react";
import {
  Button,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Box,
  Text,
  VStack,
  HStack,
  Flex,
  Divider,
} from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import { handleDownloadExcel } from "./utils/functions";

const MailModal = ({
  isOpen,
  onClose,
  fieldName,
  setFieldName,
  transformedData,
  values,
  sendMail,
  fileData,
  setFileData,
  setFinalResults,
}: any) => {
  const [currentEmail, setCurrentEmail] = useState<string>(""); // Current input value
  const { toastNotify } = useContext(AppContext);

  const handleClose = () => {
    setFieldName([]);
    setCurrentEmail(""); // Reset input
    onClose();
  };
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleAddEmail = () => {
    if (currentEmail.trim() === "") {
      toastNotify({
        title: "Empty input.",
        message: "Please enter an email address.",
        type: "warning",
      });
      return;
    }

    if (!emailRegex.test(currentEmail.trim())) {
      toastNotify({
        title: "Invalid email.",
        message: "Please enter a valid email address.",
        type: "info",
      });
      return;
    }

    setFieldName((prevEmails: any) => [...prevEmails, currentEmail.trim()]); // Add valid email to the list
    setCurrentEmail(""); // Clear the input after adding
  };


  const handleMails = (name: string) => {
    setFieldName(fieldName.filter((it: any) => name !== it));
  };


  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddEmail();
    }
  };



  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      isCentered
      size={{ base: "xs", md: "md", lg: "lg" }}
    >
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent
        bg="gray.50"
        boxShadow="xl"
        borderRadius="lg"
        overflow="hidden"
        _focus={{ outline: "none" }}
      >
        <ModalHeader
          bg="teal.500"
          color="white"
          fontSize={{ base: "lg", md: "2xl" }}
          fontWeight="700"
          px={6}
          py={4}
        >
          Enter Email(s)
        </ModalHeader>
        <ModalCloseButton
          color="white"
          _hover={{ bg: "teal.600" }}
          _focus={{ boxShadow: "none" }}
        />
        <ModalBody py={6} px={6}>
          <VStack spacing={6} align="stretch">
            <HStack width="100%" spacing={4}>
              <Input
                placeholder="Enter email"
                value={currentEmail}
                onChange={(e) => setCurrentEmail(e.target.value)}
                onKeyDown={handleKeyDown} // Add event listener for Enter key
                bg="white"
                borderColor="purple.300"
                _hover={{ borderColor: "teal.400" }}
                _focus={{ borderColor: "teal.500", boxShadow: "outline" }}
              />
              <Button
                onClick={handleAddEmail}
                bg="teal.500"
                color="white"
                _hover={{ bg: "teal.600" }}
                _active={{ bg: "teal.700" }}
              >
                Add
              </Button>
            </HStack>

            {/* Divider for visual separation */}
            <Divider borderColor="gray.300" />

            {/* Display list of emails */}
            <Box>
              {fieldName?.length > 0 ? (
                <Box>
                  <Text fontWeight="bold" mb={2} color="teal.700">
                    Added Emails:
                  </Text>
                  <VStack align="stretch" spacing={2}>
                    {fieldName.map((email: any, index: any) => (
                      <Flex
                        key={index}
                        align="center"
                        justify="space-between"
                        bg="white"
                        borderWidth="1px"
                        borderRadius="md"
                        p={3}
                        boxShadow="sm"
                      >
                        <Text fontSize="md">{email}</Text>
                        <Button
                          size="sm"
                          colorScheme="red"
                          variant="ghost"
                          onClick={() => handleMails(email)}
                        >
                          Remove
                        </Button>
                      </Flex>
                    ))}
                  </VStack>
                </Box>
              ) : (
                <Text textAlign="center" color="gray.500">
                  No emails added yet.
                </Text>
              )}
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter bg="purple.50" py={4}>
          <Button
            width="100%"
            colorScheme="teal"
            onClick={() => {
              handleDownloadExcel(
                transformedData,
                values,
                toastNotify,
                sendMail,
                fieldName,
                fileData,
                setFileData,
                setFinalResults
              );
              handleClose();
            }}
          >
            Send
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default MailModal;
